import { Component, ReactNode } from 'react';
import { Maybe } from '../../types';

interface DelayProps {
  delayMs: number;
  render: (b: boolean) => ReactNode;
}

interface DelayState {
  timeoutDone: boolean;
}

export default class Delay extends Component<DelayProps, DelayState> {
  public state = {
    timeoutDone: false
  };

  public timeoutID: Maybe<NodeJS.Timeout> = null;

  public onTimeout = () => {
    this.setState({
      timeoutDone: true
    });
  };

  public componentDidMount() {
    this.timeoutID = setTimeout(this.onTimeout, this.props.delayMs);
  }

  public componentWillUnmount() {
    // `x != null` is a shortcut for
    // `x !== null && y !== undefined`
    this.timeoutID != null && clearTimeout(this.timeoutID);
  }

  public render() {
    const { render } = this.props;
    const { timeoutDone } = this.state;
    return render(timeoutDone);
  }
}
